export default "__VITE_ASSET__9820e41c__"